import axios from 'axios'
import { ref } from 'vue'
import { APIS_GESTOR, APIS_LTE, TIMEOUTTIME } from '@/constants/apis'
import { showConsoleError } from '@/functions/errors';
import { DATABASEINFO, ENLACES, ENLACEBYNAME, LTE_ENLACES, LTE_PARAM, LASTENLACEINFO, ALLDATAINFO } from '@/interfaces/GestorHCGLINK/Equips';
import { EQUIPOS } from '@/interfaces/SmartLink/Equipos';
import { TOKEN } from '@/constants/labels';
// const TIMEOUT = TIMEOUTTIME

export async function getMaxDatesLTEGestor() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_GESTOR.value.getMaxDatesLTE, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<string[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalData.forEach((item: EQUIPOS) => {
          if (item.fecha) finalObj.value.push(item.fecha);
        })
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}



export async function getLastDatesLTEGestor(params: LTE_PARAM) {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_GESTOR.value.getLastLTE, { params: params, timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: LTE_ENLACES[] = response.data;
      const finalObj = ref<LASTENLACEINFO>({})
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {

        const enlaceByName = ref<ENLACEBYNAME>({})

        finalData.forEach((item: DATABASEINFO) => {
          const enlaces = JSON.parse(item.enlaces);
          if (enlaces.length > 0) {
            if (!finalObj.value[item.ip]) {
              finalObj.value[item.ip] = [];

              enlaces.forEach((enlace: ENLACES) => {
                enlaceByName.value[enlace.ifDescr] = {
                  [item.ip]: {
                    RXBytes: parseInt(enlace.RXBytes),
                    TXBytes: parseInt(enlace.TXBytes)
                  }
                }
              })
            } else {
              const finalEnlaces = ref<ENLACES[]>([]);
              enlaces.forEach((enlace: ENLACES) => {
                const prevObj: ENLACES = {
                  ifDescr: enlace.ifDescr.split("\"")[1].toUpperCase(),
                  ifMtu: enlace.ifMtu,
                  ifSpeed: enlace.ifSpeed,
                  RXBytes: ((parseInt(enlace.RXBytes) - enlaceByName.value[enlace.ifDescr][item.ip].RXBytes) / 1024).toFixed(2),
                  TXBytes: ((parseInt(enlace.TXBytes) - enlaceByName.value[enlace.ifDescr][item.ip].TXBytes) / 1024).toFixed(2),
                  ip: enlace.ip,
                }
                finalEnlaces.value.push(prevObj)
              })
              finalObj.value[item.ip] = finalEnlaces.value;
              // enlaceByName = {};
            }
          }

        })
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}



export async function getLast30DaysLTEGestor() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_GESTOR.value.getLast30DaysLTE, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData = response.data;
      const finalObj = ref<ALLDATAINFO>({})
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalData.forEach((item: DATABASEINFO) => {
          const enlaces = JSON.parse(item.enlaces);
          if (enlaces.length > 0) {
            if (!finalObj.value[item.ip]) {
              finalObj.value[item.ip] = {};
            }
            enlaces.forEach((enlace: ENLACES) => {
              const interfaceName = enlace.ifDescr?.split("\"")[1].toUpperCase() ?? 'item';
              if (!finalObj.value[item.ip][interfaceName]) {
                finalObj.value[item.ip][interfaceName] = {
                  rxbytes: [],
                  txbytes: []
                };
              }
              const tiempo = new Date(item.fecha);
              const milliseconds = tiempo.getTime();
              finalObj.value[item.ip][interfaceName].rxbytes.push([milliseconds, parseInt(enlace.RXBytes)]);
              finalObj.value[item.ip][interfaceName].txbytes.push([milliseconds, parseInt(enlace.TXBytes)]);
            });
          }
        })
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}



export async function getItemsTablesGestor() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_LTE.value.getIPLTE, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<EQUIPOS[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}